import Glide from '@glidejs/glide'
import { onReady } from './utils/on-ready';

export class BlogCarousel {
    constructor() {
        onReady(this.initialize);
    }

    glider;

    initialize = () => {
        if (document.querySelector('.glide.blog-carousel')) {
            this.glider = new Glide('.glide.blog-carousel', {
                type: 'carousel',
                gap: 0,
                autoplay: false,
                dragThreshold: false
            }).mount();
        }
    }
}

